import { render, staticRenderFns } from "./StepScaleStars.vue?vue&type=template&id=6b2bed66&scoped=true&"
import script from "./StepScaleStars.vue?vue&type=script&lang=js&"
export * from "./StepScaleStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2bed66",
  null
  
)

export default component.exports